import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Avatar
} from '@mui/material';
import { Business } from '@mui/icons-material';

const PharmacyDetailsStep = ({
  formik,
  logoPreview,
  handleFileChange,
  removeLogo,
  textFieldStyles
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#f9f9f9',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        margin: 'auto'
      }}
    >
      {/* Section Title */}
      <Typography variant='h5' gutterBottom sx={{ color: '#1976d2', textAlign: 'center', mb: 3, fontWeight: 'bold' }}>
        <Business sx={{ verticalAlign: 'middle', mr: 1 }} />
        Pharmacy Details
      </Typography>

      {/* Logo Upload Section */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box
          sx={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 'auto',
            backgroundColor: '#d4d4d4',
            position: 'relative'
          }}
        >
          {logoPreview || formik.values.logo
            ? (
              <Avatar
                src={logoPreview || (typeof formik.values.logo === 'string' ? formik.values.logo : '')}
                sx={{ width: '100%', height: '100%' }}
              />
              )
            : (
              <Typography variant='h4' sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                {formik.values.pharmacy_name ? formik.values.pharmacy_name.charAt(0) : 'P'}
              </Typography>
              )}
        </Box>

        <Button
          component='label'
          variant='contained'
          sx={{
            mt: 2,
            backgroundColor: '#1976d2',
            color: '#fff',
            '&:hover': { backgroundColor: '#155a9f' },
            borderRadius: '6px',
            padding: '10px 20px'
          }}
        >
          Upload Logo
          <input
            type='file'
            name='logo'
            accept='.jpg,.png,.jpeg'
            hidden
            onChange={handleFileChange}
          />
        </Button>

        {formik.values.logo && (
          <Button
            variant='text'
            color='error'
            sx={{ mt: 1 }}
            onClick={removeLogo}
          >
            Remove Photo
          </Button>
        )}
      </Box>

      {/* Pharmacy Information Section */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            name='pharmacy_name'
            label='Pharmacy Name'
            fullWidth
            required
            error={!!formik.errors.pharmacy_name}
            helperText={formik.errors.pharmacy_name}
            onChange={formik.handleChange}
            value={formik.values.pharmacy_name}
            sx={textFieldStyles}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name='owner_name'
            label='Owner Name'
            fullWidth
            required
            error={!!formik.errors.owner_name}
            helperText={formik.errors.owner_name}
            onChange={formik.handleChange}
            value={formik.values.owner_name || ''}
            sx={textFieldStyles}
          />
        </Grid>
      </Grid>

      {/* Pharmacy Bio / Description */}
      <TextField
        name='bio'
        label='Pharmacy Bio / Description'
        fullWidth
        multiline
        rows={3}
        required
        error={!!formik.errors.bio}
        helperText={formik.errors.bio}
        onChange={formik.handleChange}
        value={formik.values.bio}
        sx={{
          backgroundColor: '#d4d4d4',
          marginTop: '2em',
          borderRadius: '8px',
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': { borderColor: '#6794b6' },
            '&.Mui-focused fieldset': { borderColor: '#3b76a2' }
          },
          '& .MuiInputLabel-root': { color: '#13334c', fontSize: { xs: '0.9em', sm: '1em' } },
          '& .MuiInputLabel-root.Mui-focused': { color: '#13334c' },
          '& .MuiOutlinedInput-input': {
            color: '#000000',
            fontSize: { xs: '0.95em', sm: '1em' },
            padding: { xs: '0.85em 0.5em', sm: '0.7em 0.5em' }
          }
        }}
      />
    </Box>
  );
};

export default PharmacyDetailsStep;
